import {
  type FlowPermissionBulkUpsertBody,
  FlowPermissionEntityType,
  type FlowPermissionListQuery,
} from 'flow-schema';

import type { Common } from '../common.js';
import {
  type AgentPermissionGroupRow,
  type OrganizationPermissionGroupRow,
  type PermissionGroupRow,
  type PermissionRole,
  type UserDirectPermissions,
} from '../models/flow/permissions.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/permissions';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    args: FlowPermissionListQuery & {
      entityType: FlowPermissionEntityType.Organization;
    }
  ): Promise<OrganizationPermissionGroupRow[]>;
  async findAll(
    args: FlowPermissionListQuery & {
      entityType: FlowPermissionEntityType.Agent;
    }
  ): Promise<AgentPermissionGroupRow[]>;
  async findAll(args: FlowPermissionListQuery): Promise<PermissionGroupRow[]>;
  async findAll(args: FlowPermissionListQuery): Promise<PermissionGroupRow[]> {
    const url = this.common.constructPath(this.baseEndpoint, args);
    const response = await this.common.getJSON(url);
    return response.permissions;
  }

  async findAllForAgents(
    args: Omit<FlowPermissionListQuery, 'entityType'> = {}
  ): Promise<AgentPermissionGroupRow[]> {
    return await this.findAll({
      ...args,
      entityType: FlowPermissionEntityType.Agent,
    });
  }

  async findAllForOrganizations(
    args: Omit<FlowPermissionListQuery, 'entityType'> = {}
  ): Promise<OrganizationPermissionGroupRow[]> {
    return await this.findAll({
      ...args,
      entityType: FlowPermissionEntityType.Organization,
    });
  }

  async updateRoleMemberships(args: FlowPermissionBulkUpsertBody): Promise<void> {
    const url = this.common.constructPath(`${this.baseEndpoint}/bulk`);
    await this.common.postJSON(url, args);
  }

  async fetchRoles(): Promise<PermissionRole[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/roles`);
    const res = await this.common.getJSON(url);
    return res.roles;
  }

  async fetchUserDirectPermissions(): Promise<UserDirectPermissions> {
    const url = this.common.constructPath(`${this.baseEndpoint}/user`);
    const res = await this.common.getJSON(url);
    return res.permissions;
  }
}
